var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup6244(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.01,
    height: 13.34,
    viewBox: "0 0 20.01 13.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6244",
    "data-name": "Group 6244",
    transform: "translate(-10650.093 -3700.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M10.569,9,7.428,12.141,6,10.713",
    transform: "translate(10651.633 3697.327)",
    fill: "none",
    stroke: "#54585d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-cloud-outline",
    "data-name": "Icon ionic-md-cloud-outline",
    d: "M17.258,11.794A6.243,6.243,0,0,0,5.586,10.127a5,5,0,0,0,.542,9.963H16.966a4.181,4.181,0,0,0,4.169-4.169A4.118,4.118,0,0,0,17.258,11.794Zm-.292,6.628H6.127a3.335,3.335,0,0,1,0-6.67h.584a4.59,4.59,0,0,1,9,1.251v.417h1.251a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(10648.968 3693.5)",
    fill: "#54585d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6244);
export default __webpack_public_path__ + "static/media/Group 6244.09ea4ae8496cea8c1fd8f1fa9e8d030b.svg";
export { ForwardRef as ReactComponent };